import { AppData, Log, Router } from '@lightningjs/sdk'
import { AdSdkConfig, AppApiConfig, LayoutConfig } from '../app-api-config'
import GridViewModel, { FocusInfo } from '../components/grid/grid-view-model'
import { ItemNode } from "../components/grid/ItemNode"
import { clearRecentlyWatched, fetchData, getBookmarkingData, getIndexUrl, getQueueItemUrl, getSearchItemUrl, getSimilarVideosUrl } from './data-service'
import NavigationStack from './navigation-stack'
import RowList from '../components/grid/row-model'
import { AppSetup } from '../app-setup'
import { AdHandler } from '../ad-handler'
import { FreeWheelAds } from '../ads-freewheel'
import { Logger } from '../logger'
import { DIALOG_BUTTON_ACTION, DIALOG_TYPE, GRIDTYPE } from '../enum'
import QueueManager from '../queue-manager'
import { Deeplink } from '../deeplink'
import { Helper } from '../helper'
import BookmarkingManager from '../bookmarking-manager'
import IMAAdHandler from '../ima-sdk/ima-ad-handler'
import EPGManager from '../components/epg/epg-model'
import BlockingManager from '../blocking-manager'
import { IDialogueButton, IDialogueInfo } from '../interfaces'

export interface IAppModel {
    l1CategoryToLoad: number
    isMainApp: boolean
    siteId: string
    isInitialized: boolean
    appApiConfig: AppApiConfig
    adHandler: AdHandler
    imaAdHandler: IMAAdHandler
    suspendedAppStack: GridViewModel[]
}
export default class AppModel implements IAppModel {
    l1CategoryToLoad = -1
    isMainApp = false
    siteId = ''
    isInitialized = false
    appApiConfig!: AppApiConfig
    suspendedAppStack: GridViewModel[] = []

    deeplink: Deeplink = new Deeplink()
    deeplinkGrid!: GridViewModel
    dynidGrid: GridViewModel | undefined = undefined
    queueGrid!: GridViewModel
    searchGrid!: GridViewModel
    videoPlaylistGrid!: GridViewModel
    similarGrid!: GridViewModel
    selectScreenLiveGrid!: GridViewModel

    navigation!: NavigationStack
    queueManager!: QueueManager
    bookmarkingManager!: BookmarkingManager
    epgManager!: EPGManager
    blockingManager!: BlockingManager

    adObj = {
        adActivation: false,
        adInterval: false,
        adProbability: false,
        adUrl: "",
        adCounter: 0,
        enableMidAd: false,
        midAdTimeInterval: 0,
        midAdRepeatMode: false,
        createView: 0,
        start: 0,
        firstQuartile: 0,
        midPoint: 0,
        thirdQuartile: 0,
        complete: 0,
        adDetails: {},
        adsdklistPriorities: new Array(),
        firstadInterval: 0,
        nonmidrollsize: 0,
        midrollsize: 0,
        adsdklist: new Array(),
    }

    ads = {
        adDisplayContainer: null,
        requestInProgress: false,
        preRollAdsPlayed: 0,
        preRollAdsRequested: 0,
        midRollAdsPlayed: 0,
        midRollAdsRequested: 0,
        adPlaying: false,
        midAdPlaying: false,
        currentVodCuePoints: new Array(),
        currentVodPlayPoints: new Array(),
        currentVodPFPoints: new Array(),
        currentVodCuePointsCopy: new Array(),
        currentVodPFInfo: {},
        adResp: '',
        currentlyRequestedAdType: 'preroll',
        adSdkCalled: 0,
        adRequestedAgo: 0,
        shouldResumeVideo: true,
        currentAdTrackers: new Array(),
        defaultAdProvider: 'ima',
        adSdksChecked: new Array(),
        adSdksCount: 0,
        skippedPods: new Array(),
        adPaused: false,
        adPlayRequested: false,
        preRollRequestMade: false,
        adHangCheck: null,
        adHangProgress: 0,
        adTimeoutBeforeDiscard: 40,
        breakPointAdMapCounter: 0,
        lastPrerollTimestamp: 0,
        adBreakNumber: 0,
        adsPlaybackRemainingTime: 240,
        adsLabelTimer: null,
        adsPlayedTime: 0,
        adscurrentController: 'freewheel',
        adsInitialized: false,
    };

    themesObj = {
        ageRatingColor: '',
        titleColor: '',
        textSize: 0,
        textcolor: '',
        gridfocuscolor: '',
        bgcolor: ''
    }

    adHandler: AdHandler = new AdHandler();
    imaAdHandler: IMAAdHandler = new IMAAdHandler();

    freeWheelAds = new FreeWheelAds().freeWheelAds;
    videoObj: any;
    adPlayObj: any;




    constructor(siteId: string, isMainApp = false) {
        this.siteId = siteId
        this.isMainApp = isMainApp
        this.appApiConfig = new AppApiConfig()
        this.navigation = new NavigationStack()
        this.queueManager = new QueueManager()
        this.bookmarkingManager = new BookmarkingManager()
        this.blockingManager = new BlockingManager()
        this.isInitialized = true
        window.currentApp = this
    }

    loadIndex = () => {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        return new Promise((resolve) => {
            let url = getIndexUrl(this.siteId)
            Log.info('Index.php request: ', url)
            const { appConfig } = AppData as AppSetup
            if (appConfig?.testIndexError) {
                url = 'https://index_404.php'
                //url.split('index.php').join('index_404.php')
            }
            fetchData(url).then((response) => {
                this.appApiConfig.init(response.data)
                Log.info('Index.php response: ', response.data, this.appApiConfig)
                resolve(true)
                this.initAdHandler();
                this.queueManager.init()
            })
                .catch((e) => {
                    const { platform } = AppData as AppSetup
                    Log.error('Index.php load error')
                    platform?.sendMetrics('error', { errorType: 'network', code: e.code, description: e.message })
                })
        })
    }

    handleBackNavigation(prevPage = '') {
        const currentRoute: string = Router.getActiveRoute()?.split('/')[0]!
        Log.info('handleBackNavigation: ', currentRoute)
        let grid = this.navigation.getCurrentGrid()
        const { platform } = AppData as AppSetup
        if (currentRoute == 'video-screen' || currentRoute == 'video-screen-live' || currentRoute == 'splash') {
            if (!platform.isVideoSuspended) {
                if (grid.type == GRIDTYPE.DYNID || grid.type == GRIDTYPE.LIVE_SELECTSCREEN) {
                    this.navigation.continuesStack.pop()
                }
                if (this.dynidGrid) {
                    this.dynidGrid.destroy()
                    this.dynidGrid = undefined
                }
            }
            this._backToGridPage(currentRoute)
        } else if (currentRoute == 'search-screen' || currentRoute == 'settings-screen') {
            if (prevPage === 'grid') {
                this._backToGridPage(currentRoute)
            } else if (prevPage === 'player') {
                this._backToPlayerPage();
            } else {
                this._backToGridPage(currentRoute)
            }
        } else if (currentRoute == 'mlp-grid-screen') {
            if (grid.isMlp && grid.mlpId !== 'search') {
                this.navigation.handleBack()
            }
            this._backToGridPage(currentRoute)
        } else if (currentRoute == 'main-grid-screen') {
            //TBD - show app exit popup to user.
        } else if (currentRoute == 'cc-setting') {
            if (prevPage === 'grid') {
                this._backToGridPage(currentRoute)
            }
            this._backToGridPage(currentRoute)
        }
    }

    private _backToGridPage(currentRoute: any) {
        const { appState, platform } = AppData as AppSetup
        let grid = this.navigation.getCurrentGrid()
        if (!grid) {
            Router.navigate('main-grid-screen/' + 0, false)
            if (currentRoute == 'video-screen') {
                Logger.processUserAction('goBacktoHomescreenFromPlayer');
            } else if (currentRoute == 'mlp-grid-screen') {
                Logger.processUserAction('goBacktoHomescreenFromListoflistScreen');
            }
            return;
        } else if (grid.type == GRIDTYPE.SEARCH) {
            this.navigation.handleBack(false)
            const { appConfig } = AppData as AppSetup;
            appConfig.useHistory = true;
            Router.navigate('search-screen/grid', false)
            if (currentRoute == 'video-screen') {
                Logger.processUserAction('goBackToSearchResultsFromPlayer');
            }
        } else if (grid.type == GRIDTYPE.DEEPLINK) {
            //if (!platform.isVideoSuspended) {
                appState?.clearDeeplink()
                if (grid.isMlp) {
                    grid.type = GRIDTYPE.MLP;
                    let item: ItemNode = grid.channelInfo as ItemNode;
                    grid.mlpId = item.id
                    Router.navigate('mlp-grid-screen/' + item.id, false)
                    if (currentRoute == 'video-screen') {
                        Logger.processUserAction('goBacktoListoflistScreenFromPlayer');
                    }
                } else {
                    this.navigation.pop();
                    Router.navigate('main-grid-screen/' + 0, false)
                    if (currentRoute == 'video-screen') {
                        Logger.processUserAction('goBacktoHomescreenFromPlayer');
                    } else if (currentRoute == 'mlp-grid-screen') {
                        Logger.processUserAction('goBacktoHomescreenFromListoflistScreen');
                    }
                }
            //}
        } else {
            if (grid.isMlp) {
                Router.navigate('mlp-grid-screen/' + grid.mlpId, false)
                if (currentRoute == 'video-screen') {
                    Logger.processUserAction('goBacktoListoflistScreenFromPlayer');
                }
            } else {
                Router.navigate('main-grid-screen/' + this.l1CategoryToLoad, false)
                if (currentRoute == 'video-screen') {
                    Logger.processUserAction('goBacktoHomescreenFromPlayer');
                }
            }
        }
    }

    private _backToPlayerPage() {
        const grid = this.navigation.getCurrentGrid()
        const vodInfo: ItemNode = grid.getFocusedItem();
        if (vodInfo.feed_type == 'video') {
            Router.navigate('video-screen/' + vodInfo.node_id + '_search', false)
        }
    }



    destroy() {
    }

    loadL1 = (l1: string, reload?: boolean): GridViewModel => {
        let gridViewModel: GridViewModel
        if (parseInt(l1) !== this.l1CategoryToLoad || reload) {
            while (this.navigation.continuesStack.length > 1) {
                this.navigation.pop()
            }
            this.l1CategoryToLoad = parseInt(l1)
            this.navigation.reset();
            const currentChannel: any = this.appApiConfig.appConfig?.channels
            gridViewModel = new GridViewModel(currentChannel[this.l1CategoryToLoad])
            gridViewModel.type = GRIDTYPE.GRID
            this.navigation.push(gridViewModel)
        } else {
            gridViewModel = this.navigation.getCurrentGrid()
        }
        return gridViewModel
    }

    loadShow = (showInfo: ItemNode, id: string): GridViewModel => {
        const currentGrid = this.navigation.getCurrentGrid()

        if (currentGrid.isMlp && currentGrid.mlpId == id) {
            const channelInfo: ItemNode = currentGrid.channelInfo as ItemNode
            channelInfo.id == showInfo.id
            return currentGrid
        }
        const gridViewModel = new GridViewModel(showInfo, true, id)
        gridViewModel.type = GRIDTYPE.MLP
        gridViewModel.parentGrid = currentGrid
        currentGrid.childGrid = gridViewModel
        this.navigation.push(gridViewModel)
        return gridViewModel
    }

    loadSearch = (searchStr: string) => {
        if (this.searchGrid !== undefined) {
            this.searchGrid.destroy()
        }
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const itemNode: ItemNode = new ItemNode()
        const scale = rowStyle.rowstyle == 'flat-movie' ? 1 : 0.85
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, 'search')
        const rowData = {
            description: 'search',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'Search: ' + searchStr,
            row_height: rowStyle.row_height * scale,
            row_item_height: rowStyle.row_item_height * scale,
            row_item_width: rowStyle.row_item_width * scale,
            rowstyle: rowStyle.rowstyle,
            row_sub_type: '',
            row_type: 'mixed-content-row',
            url: getSearchItemUrl(searchStr)
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.type = GRIDTYPE.SEARCH
        this.searchGrid = gridViewModel
        return this.searchGrid
    }

    loadVideoPlaylist = () => {
        Log.info('loadVideoPlaylist', this.navigation.continuesStack)
        if (this.videoPlaylistGrid !== undefined) {
            this.videoPlaylistGrid.destroy()
        }
        let currentGrid: GridViewModel = this.navigation.getCurrentGrid();
        let focusInfo: FocusInfo = currentGrid.getFocusInfo();
        let currentRow: RowList = currentGrid.getRowAt(focusInfo.focusRow);
        let vodInfo: ItemNode = currentGrid.getFocusedItem()
        //const uiRow:any = currentGrid.getUiRowAt(focusInfo.focusRow);
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel: GridViewModel = new GridViewModel(itemNode, true, 'videoplaylist')
        let dynidGrid: GridViewModel
        let dynidRow: RowList

        if (currentGrid.type == GRIDTYPE.DYNID) {
            currentGrid = this.navigation.getNonDynamicGrid()
            focusInfo = currentGrid.getFocusInfo();
            currentRow = currentGrid.getRowAt(focusInfo.focusRow);
            vodInfo = currentGrid.getFocusedItem()
            dynidGrid = this.dynidGrid
            dynidRow = dynidGrid.getRowAt(0)!
            gridViewModel.add(dynidRow, 0)
            gridViewModel.add(currentRow, 1)
            focusInfo = dynidGrid.getFocusInfo();
        } else {
            currentRow.playlistRowName = 'Current video list'
            if (!Helper.isEmpty(vodInfo.deeplink_url)) {
                dynidGrid = this.loadDynid(vodInfo.deeplink_url, vodInfo.node_id, currentRow)
                dynidRow = dynidGrid.getRowAt(0)!
                gridViewModel.add(currentRow, 0)
                gridViewModel.add(dynidRow, 1)
            } else {
                gridViewModel.add(currentRow, 0)
            }
        }
        gridViewModel.type = GRIDTYPE.VIDEOPLAYLIST
        gridViewModel.createGridListUI()
        gridViewModel.focusInfo = {
            focusRow: 0, foucsItem: focusInfo.foucsItem
        }
        this.videoPlaylistGrid = gridViewModel

        return this.videoPlaylistGrid
    }

    loadQueuePlaylist = (reload = false) => {
        if (this.queueGrid !== undefined || reload) {
            this.queueGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, GRIDTYPE.QUEUE)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'queue',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'Queue',
            row_sub_type: '',
            row_type: 'mixed-content-row',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: getQueueItemUrl()
        }

        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.type = GRIDTYPE.QUEUE
        this.queueGrid = gridViewModel
        return this.queueGrid
    }

    loadSimilarVideos(vodInfoId) {
        if (this.similarGrid !== undefined) {
            this.similarGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, vodInfoId)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'similar',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'Similar Videos',
            row_sub_type: '',
            row_type: 'mixed-content-row',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: getSimilarVideosUrl(vodInfoId)
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.SIMILAR_VIDEOS
        this.similarGrid = gridViewModel
        return this.similarGrid
    }

    loadLiveTvfromSelectScreen(url) {
        if (this.selectScreenLiveGrid !== undefined) {
            this.selectScreenLiveGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, '0')
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle()
        const rowData = {
            description: 'live tv from select',
            dynamic_deeplink: '',
            feed_type: 'live',
            name: 'Live Tv',
            row_sub_type: '',
            row_type: 'live',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: url
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.LIVE_SELECTSCREEN
        this.selectScreenLiveGrid = gridViewModel
        return this.selectScreenLiveGrid
    }

    loadEpg(url?: any, rowlist?: RowList, currIndex = 0): EPGManager {
        if (!this.epgManager || this.epgManager.url !== url) {
            this.epgManager = new EPGManager(url, rowlist)
        } else {
            this.epgManager.currIndex = currIndex
        }
        return this.epgManager
    }

    loadDynid(dynidUrl, vodInfoId, currentRow) {
        if (this.dynidGrid !== undefined) {
            this.dynidGrid.destroy()
        }
        const itemNode: ItemNode = new ItemNode()
        itemNode.type = 'listoflist'
        let gridViewModel = new GridViewModel(itemNode, true, vodInfoId)
        const rowStyle: { row_height: number, row_item_height: number, row_item_width: number, rowstyle: string } = Helper.getRowStyle(currentRow)
        const rowData = {
            description: 'dynid',
            dynamic_deeplink: '',
            feed_type: 'video',
            name: 'You may also like',
            row_sub_type: '',
            row_type: 'mixed-content-row',
            row_height: rowStyle.row_height,
            row_item_height: rowStyle.row_item_height,
            row_item_width: rowStyle.row_item_width,
            rowstyle: rowStyle.rowstyle,
            url: dynidUrl
        }
        const rowList = new RowList(rowData)
        gridViewModel.add(rowList)
        gridViewModel.createGridListUI()
        gridViewModel.type = GRIDTYPE.DYNID
        this.dynidGrid = gridViewModel
        return this.dynidGrid
    }

    loadDeeplinkInterrupt(playIdUrl: string) {
        const { appState } = AppData as AppSetup
        if (!Helper.isEmpty(playIdUrl)) {
            const deeplink = this.deeplink;
            deeplink.getDeeplinkingParams(playIdUrl, this);
            if (appState.playlistPlayMode && !appState.deeplinks.isInvalidPattern) {
                deeplink.loadPlaylistAndPlay();
                appState.isDeeplinkInterupped = true;
            } else {
                deeplink.handleError();
            }
        }
    }

    handleAppExit() {
        const { platform } = AppData as AppSetup
        if (platform?._shouldShowExitPopup) {
            const dialogInfo: IDialogueInfo = {
                title: 'Confirm',
                body: 'Are you sure you want to exit the app?',
                type: DIALOG_TYPE.APP_EXIT_BOX,
                buttons: [
                    {
                        w:250,
                        name: 'No',
                        index: 0,
                        action: DIALOG_BUTTON_ACTION.NO,
                        initialFocus: true,
                    },
                    {
                        w:250,
                        name: 'Yes',
                        index: 1,
                        action: DIALOG_BUTTON_ACTION.YES,
                        initialFocus: false
                    }
                ],
                callback: this.handleExitPopupHandler.bind(this)
            }
            const page = Router.getActivePage()
            page.widgets.dialog.showDialog(dialogInfo)
            Router.focusWidget('dialog')
            return true
        } else {
            Logger.processUserAction('userExitedViaRemoteDirectlyFromGrid');
            platform?.sendMetrics('close', { reason: "user exit on back" })
        }
    }

    handleExitPopupHandler(selected: IDialogueButton) {
        const { platform } = AppData as AppSetup
        if (selected.action == DIALOG_BUTTON_ACTION.YES) {
            Logger.processUserAction('userExitedViaRemoteDirectlyFromGrid');
            platform?.sendMetrics('close', { reason: "user exit on back" })
        } else {
            Router.focusPage()
        }
    }

    reloadAppOnParentalControlChange(aContent) {
        const { appConfig } = AppData as AppSetup;
        this.navigation.reset()
        appConfig.aContent = aContent
        Router.navigate('main-grid-screen/' + this.l1CategoryToLoad + '_true_' + new Date().getTime(), false)
    }

    getNextItem = async (): Promise<ItemNode> => {

        let gridViewModel = this.navigation.getCurrentGrid()
        let currentVodInfo = gridViewModel.getFocusedItem()
        let shouldreturnOnDynid = false;
        if (gridViewModel.type !== GRIDTYPE.DYNID &&
            this.dynidGrid &&
            this.dynidGrid.mlpId == currentVodInfo.node_id
        ) {
            this.navigation.push(this.dynidGrid)
            gridViewModel = this.navigation.getCurrentGrid()
            currentVodInfo = gridViewModel.getFocusedItem()
            shouldreturnOnDynid = true;
        }
        // removed the nested dynid  condition
        // else if (gridViewModel.type == GRIDTYPE.DYNID && !Helper.isEmpty(currentVodInfo.deeplink_url)) {
        //     this.loadDynid(currentVodInfo.deeplink_url, currentVodInfo.node_id)
        //     await this.dynidGrid.fetchInitialRows()
        //     this.navigation.pop()
        //     this.navigation.push(this.dynidGrid)
        //     gridViewModel = this.navigation.getCurrentGrid()
        //     currentVodInfo = gridViewModel.getFocusedItem()
        //     shouldreturnOnDynid = true;
        // }
        if (shouldreturnOnDynid) {
            if (!this.blockingManager.isItemBlocked(currentVodInfo)) {
                return currentVodInfo;
            }
        }
        let vodInfo = null
        let exit = false
        // this loop is the scenario for the nested mlp / mlp last video if the current playing
        // video is the last element in the nested mlp se need to pop out and if previous level mlp is also the last element we need to recursively pop out of the stack.
        while (!exit) {
            vodInfo = await gridViewModel.getNextItem()!
            if (vodInfo == null) {
                if (gridViewModel.type == "deeplink") {
                    let focusInfo = gridViewModel.getFocusInfo();
                    focusInfo.foucsItem = 0;
                    gridViewModel.changeFocus(focusInfo);
                    vodInfo = gridViewModel.getFocusedItem();
                } else {
                    gridViewModel.destroy();
                    this.navigation.pop();
                    gridViewModel = this.navigation.getCurrentGrid()
                    vodInfo = (await gridViewModel.getNextItem())!
                }
            }
            if (vodInfo && !vodInfo.blockItem) {
                exit = true
            }
        }
        exit = false
        // this loop is for entering into the nested levels if the next item in the current level grid is a MLP Item.
        while (!exit) {
            if (vodInfo?.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
                const listGrid: GridViewModel = this.loadShow(vodInfo, vodInfo.id)
                await listGrid.fetchInitialRows()
                listGrid.createGridListUI()
                vodInfo = listGrid.getFocusedItem()
            } else {
                exit = true
            }
        }
        return vodInfo
    }

    getPrevItem = async (): Promise<ItemNode> => {
        let gridViewModel = this.navigation.getCurrentGrid()
        let currentVodInfo = gridViewModel.getFocusedItem()
        let shouldreturnOnDynid = false;
        if (gridViewModel.type !== GRIDTYPE.DYNID &&
            this.dynidGrid &&
            this.dynidGrid.mlpId == currentVodInfo.node_id
        ) {
            this.navigation.push(this.dynidGrid)
            gridViewModel = this.navigation.getCurrentGrid()
            currentVodInfo = gridViewModel.getFocusedItem()
            shouldreturnOnDynid = true;
        }
        // removed the nested dynid  condition
        // else if (gridViewModel.type == GRIDTYPE.DYNID && !Helper.isEmpty(currentVodInfo.deeplink_url)) {
        //     this.loadDynid(currentVodInfo.deeplink_url, currentVodInfo.node_id)
        //     await this.dynidGrid.fetchInitialRows()
        //     this.navigation.pop()
        //     this.navigation.push(this.dynidGrid)
        //     gridViewModel = this.navigation.getCurrentGrid()
        //     currentVodInfo = gridViewModel.getFocusedItem()
        //     shouldreturnOnDynid = true;
        // }
        if (shouldreturnOnDynid) {
            if (!this.blockingManager.isItemBlocked(currentVodInfo)) {
                return currentVodInfo;
            }
        }
        let vodInfo = null
        let exit = false
        while (!exit) {
            vodInfo = (await gridViewModel.getPrevItem())!
            if (vodInfo == null) {
                if (!gridViewModel.parentGrid) {
                    let focusInfo = gridViewModel.getFocusInfo();
                    focusInfo.foucsItem = 0;
                    gridViewModel.changeFocus(focusInfo);
                    vodInfo = gridViewModel.getFocusedItem();
                } else {
                    gridViewModel.destroy();
                    this.navigation.pop();
                    gridViewModel = this.navigation.getCurrentGrid()
                    vodInfo = (await gridViewModel.getPrevItem())!
                }
            }
            if (vodInfo && !vodInfo.blockItem) {
                exit = true
            } else if (
                gridViewModel.getFocusInfo().focusRow == 0 &&
                gridViewModel.getFocusInfo().foucsItem == 0 &&
                !gridViewModel.parentGrid
            ) {
                if (vodInfo && !vodInfo.blockItem) {
                    // if the main grid or standalone grid 1st item is reached and is blocked
                    // traverse forward to pick the next unblock item
                    vodInfo = this.getNextItem()
                    exit = true
                }
            }
        }
        exit = false
        while (!exit) {
            if (vodInfo.type == 'listoflist' || vodInfo.type == 'new-qid' || vodInfo.feed_type == 'banner') {
                const listGrid: GridViewModel = this.loadShow(vodInfo, vodInfo.id)
                await listGrid.fetchInitialRows()
                listGrid.createGridListUI()
                vodInfo = listGrid.getFocusedItem()
                if (vodInfo && vodInfo.blockItem) {
                    vodInfo = await listGrid.getNextItem()
                }
            } else {
                exit = true
            }
        }
        return vodInfo
    }
    initAdHandler = () => {
        if (!this.adHandler.isInitialized) {
            this.adHandler.createAdVideoElem();
            this.imaAdHandler.setUpIMA();
            this.adHandler.initializeAdsConfig();
        }
    }

    clearRecentlyWatched(){
        return new Promise((resolve, reject)=>{
            const url = clearRecentlyWatched()
            Log.info('Index.php request: ', url)
            // Router.focusPage()
            fetchData(url).then((response) => {
                this.navigation.getCurrentGrid().resetGrid()
                // Router.reload()
                resolve(true)
            })
        })
        
    }

}
